import { Empty } from "antd"
import React from "react"

type MapType = "roadmap" | "satellite" | "hybrid" | "terrain"

interface AddressMapPreviewProps {
  fullAddress?: string | null
  height?: number | string
  zoom?: number
  language?: string
  region?: string
  mapType?: MapType
  interactive?: boolean
  className?: string
  emptyText?: string
}

const mapTypeMap: Record<MapType, string> = {
  roadmap: "m",
  satellite: "k",
  hybrid: "h",
  terrain: "p"
}

export function AddressMapPreview({
  fullAddress,
  height = 200,
  zoom = 15,
  language = "en",
  region = "us",
  mapType = "roadmap",
  interactive = false,
  className = "",
  emptyText = "Enter full address to see map preview"
}: AddressMapPreviewProps) {
  if (!fullAddress) {
    return (
      <div
        className={`w-full bg-gray-100 rounded-lg flex items-center justify-center mb-4 ${className}`}
        style={{ height }}
      >
        <Empty description={emptyText} style={{ margin: "auto" }} />
      </div>
    )
  }

  const params = new URLSearchParams({
    q: fullAddress,
    hl: language,
    gl: region,
    z: String(zoom),
    t: mapTypeMap[mapType],
    output: "embed"
  })

  return (
    <div
      className={`w-full rounded-lg overflow-hidden mb-4 ${className}`}
      style={{ height }}
    >
      {/*<iframe*/}
      {/*  width="100%"*/}
      {/*  height="100%"*/}
      {/*  style={{ border: 0 }}*/}
      {/*  loading="lazy"*/}
      {/*  referrerPolicy="no-referrer-when-downgrade"*/}
      {/*  src={`https://www.google.com/maps/embed/v1/place?key=YOUR_API_KEY&q=place_id:${selectedAddress.address.place_id}`}*/}
      {/*/>*/}

      {/*<iframe*/}
      {/*  width="100%"*/}
      {/*  height="100%"*/}
      {/*  style={{ border: 0 }}*/}
      {/*  loading="lazy"*/}
      {/*  referrerPolicy="no-referrer-when-downgrade"*/}
      {/*  src={`https://maps.google.com/maps?q=${encodeURIComponent(selectedAddress.address.display)}&z=15&output=embed`}*/}
      {/*/>*/}

      <iframe
        width="100%"
        height="100%"
        style={{
          border: 0,
          borderRadius: 8
          // pointerEvents: interactive ? "auto" : "none"
        }}
        loading="lazy"
        src={`https://maps.google.com/maps?${params.toString()}`}
      />
    </div>
  )
}
